import * as angular from 'angular';
import FlowModelSummaryListBridge from './FlowModelSummaryListBridge';
angular
  .module('flowingly.components')
  .component('flowModelSummaryList', FlowModelSummaryListBridge);
